import { Controller } from "@hotwired/stimulus"
import http from "helpers/http"

export default class extends Controller {
  static targets = ["promotionForm"]

  static values = {
    teamMemberId: Number,
    teamSubscriptionId: Number,
    url: String
  }

  showPromotionForm() {
    this.fetch(this.urlValue)
  }

  hidePromotionForm() {
    this.promotionFormTarget.innerHTML = ""
  }

  // private

  fetch(url) {
    http.get(url)
      .json()
      .then(response => {
        // eslint-disable-next-line no-unsanitized/property -- the response is a form rendered by our own member controller
        this.promotionFormTarget.innerHTML = response.body
      })
  }
}
